<template>
  <div id="cash_tax_request" class="layer-area plp-v2 plp-v2-st2" :class="classDisplayPopup">
    <div class="layer-area_container with_pop_head  shipping_delivery_st02">
      <div class="layer-prd_search_top cash_tax">
        <div class="pop_head">
          <span><button class="btn_back"><em class="sp_ic">이전</em></button></span>
          <h2 class="tax">현금영수증 신청</h2>
        </div>

        <div class="layer-content-cash new-payment gift_order renew">
          <dl class="cash_tax tab_control0 tab-area">
            <dt>
              <input
                class="amwa-radio"
                type="radio"
                name="paymentCardMode0"
                id="cash_01"
                value="none"
                checked="checked"
                v-model="contentToBeDisplayed"
              >
              <label for="cash_01"><span>신청안함</span></label>
            </dt>
            <dt>
              <input
                class="amwa-radio"
                type="radio"
                name="paymentCardMode0"
                id="cash_02"
                value="CASH"
                v-model="contentToBeDisplayed"
              >
              <label for="cash_02"><span>현금영수증</span></label>
            </dt>
            <dd
              class="tab_control tab-cont-st0"
              :style="styleDisplayContent"
              id="cash_02_cont"
            >
              <div class="taxbill">
                <div class="tab-area-out">
                  <div class="tab-area with50">
                    <div class="tab-head" role="tab">
                      <input
                        class="amwa-radio"
                        type="radio"
                        name="paymentCardMode"
                        id="cash_02_01"
                        value=""
                        checked="checked"
                      >
                      <label for="cash_02_01" class="focus subtax">개인 소득공제용</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mgt10">
                <div class="tab-cont-st2" id="cash_02_01_cont">
                  <span class="form_select-default">
                    <select
                      class="form_select"
                      id="creditCardKind"
                      v-model="receiptRegType"
                    >
                      <option value="" disabled selected> 현금영수증 발행 선택 </option>
                      <option value="CPN">휴대폰번호</option>
                      <option value="CDN">현금영수증카드번호</option>
                    </select>
                    <input
                      type="text"
                      placeholder="‘-’없이 입력"
                      id="receiptIssuanceNumber"
                      maxlength="18"
                      class="form-control mgt5 form_input"
                      v-model="receiptNumber"
                    >
                  </span>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div class="layer-area_bottom01">
        <div class="align-box size-auto">
          <button
            type="button"
            class="btn-modal_close v2"
            @click="$emit('close-modal', true)"
          >취소</button>
          <button
            type="button"
            class="btn-modal_apply"
            @click="onClickSelect"
          >선택</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PopupCashReceipt",
  data() {
    return {
      receiptCategory: "CASH",
      receiptNumber: "",
      receiptRegType: "",
      contentToBeDisplayed: "none",
    }
  },
  computed: {
    classDisplayPopup() {
      return this.displayModal ? "showing": "";
    },
    styleDisplayContent() {
      return this.contentToBeDisplayed === "CASH" ? {display: 'block'} : {display: 'none'};
    }
  },
  mounted() {
    if(this.cashReceipt) {

      this.contentToBeDisplayed = this.cashReceipt.applying === "CASH" ? "CASH" : "none";
      this.receiptCategory = this.contentToBeDisplayed;
      this.receiptNumber = this.cashReceipt.regTypeNum;
      this.receiptRegType = this.cashReceipt.cashReceiptRegType;
    }
  },
  props: {
    displayModal: {
      type: Boolean,
      default: false,
    },
    cashReceipt: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onClickSelect() {

      //FIXME 신청안함으로 했을 때 내용 초기화.

      let receiptInfo = this.contentToBeDisplayed === 'CASH' ? {
        applying: this.contentToBeDisplayed,
        cashReceiptCategory: "INCOME_DEDUCTION",
        cashReceiptRegType: this.receiptRegType,
        regTypeNum: this.receiptNumber
      } : {
        applying: "none",
        cashReceiptCategory: "INCOME_DEDUCTION",
        cashReceiptRegType: "",
        regTypeNum: ""
      };

      this.$emit('update-receipt-info', receiptInfo);
      this.$emit('close-modal', true);
    },
  },
}
</script>

<style scoped>
select option[value=""][disabled] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/order/main/components/PopUpWrappers/PopupCashReceipt.vue